// extracted by mini-css-extract-plugin
export default {"root":"UserEmotionSelect_root__Xz-IV","itemWrapper":"UserEmotionSelect_itemWrapper__Jul+5","item":"UserEmotionSelect_item__7Q-J-","input":"UserEmotionSelect_input__PybPb"};